<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <div class="row p-1 align-items-center justify-content-center mt-2">
    <div
      class="card mb-1 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
      v-if="discountCodeData.length == 0"
    >
      <div class="card-body">
        <div class="w-100 pt-1 text-center">
          <strong class="d-block fs-6 fw-medium">
            کد تخفیفی در حساب شما ثبت نشده است</strong
          >
        </div>
      </div>
    </div>
    <div class="col-md-11 bg-white" v-if="discountCodeData.length != 0">
      <div class="m-2">
        <div class="card-body">
          <div class="row align-items-center justify-content-center g-2">
            <!-- class="col-12 col-md-6 col-lg-5 col-xl-4" -->
            <div
              class="col-md-4"
              v-for="item in discountCodeData"
              :key="item.id"
            >
              <div
                class="card border-0 shadow"
                :class="isMobile ? 'my-1' : 'my-4'"
              >
                <div
                  class="rounded-xl rounded-bottom-0 py-1"
                  :class="{
                    'bg-primary-soft': item.isValid,
                    'bg-danger-soft': !item.isValid,
                  }"
                >
                  <div class="clearfix">
                    <div class="text-center fw-light float-start pt-2 pe-4">
                      {{ item.isValid ? item.remainSessionCount : 0 }}
                      جلسه باقی مانده
                    </div>
                    <h3 class="text-center mb-0 float-end ps-1">
                      <span class="fs14px p-2">
                        <!-- :class="{ 'text-success': item.isValid }" -->
                        <span class="mb-0 mt-3">%</span>
                        <!-- :class="{ 'text-success': item.isValid }" -->
                        <span class="mb-0">{{ item.discountPercent }}</span>
                      </span>
                    </h3>
                  </div>

                  <div class="clearfix text-center fs12px m-0 p-0">
                    {{ item.code }}
                  </div>
                </div>

                <div class="p-2 p-lg-2">
                  <div class="d-flex mb-2">
                    <div
                      class="badge badge-ico-sm rounded-circle float-start"
                      :class="{
                        'bg-primary-soft': item.isValid,
                        'bg-danger-soft': !item.isValid,
                      }"
                    >
                      <i class="fi fi-check"></i>
                    </div>

                    <p class="text-dark fw-light mb-0 px-1 small">
                      معتبر تا {{ getPersianDate(item.finishDate) }}
                      <small
                        class="gregorianDateClass"
                        dir="ltr"
                        v-if="isOverseas()"
                      >
                        | {{ getGregorianDate(item.finishDate) }}
                      </small>
                    </p>
                  </div>
                  <div class="d-flex mb-2">
                    <div
                      class="badge badge-ico-sm rounded-circle float-start"
                      :class="{
                        'bg-primary-soft': item.isValid,
                        'bg-danger-soft': !item.isValid,
                      }"
                    >
                      <i class="fi fi-check"></i>
                    </div>

                    <p
                      class="text-dark fw-light mb-0 px-1 small"
                      v-if="item.therapyTypeTitle || item.sessionTypeTitle"
                    >
                      جلسات: {{ item.therapyTypeTitle }} -
                      {{ item.sessionTypeTitle }}
                    </p>
                    <p
                      class="text-dark fw-light mb-0 px-1 small"
                      v-if="!item.therapyTypeTitle && !item.sessionTypeTitle"
                    >
                      قابل استفاده در تمامی جلسات
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import axios from 'axios';
export default {
  components: { LoadingSpinner },
  data() {
    return {
      isMobile: isMobile,
      discountCodeData: [],
    };
  },
  methods: {
    getPersianDate(date) {
      if (!date) {
        return '';
      }
      /* eslint-disable */
      return new persianDate(new Date(date)).format('L');
    },
    getGregorianDate(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
    async getDiscountCodeData() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .get(
          `/FN/DiscountCode/GetPersonDiscountCode/${that.$store.getters.userPersonID}`
        )
        .then((response) => {
          that.discountCodeData = response.data;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت کد های تخفیف با مشکل مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner?.hide();
        });
    },
  },
  async mounted() {
    let that = this;

    await that.getDiscountCodeData();
  },
};
</script>
